import Layout from "@/views/layout/layout";
const rootPath = "/fore";

const foreignExchange = {
  path: rootPath,
  name: "foreign",
  description: "외환",
  redirect: rootPath + "/ovsesRmtancAplcnInfoInptReq",
  component: Layout,
  children: [
    {
      path: "ovsesRmtancAplcnInfoInptReq",
      name: "ovsesRmtancAplcnInfoInptReq",
      redirect: { name: "ovsesRmtancAplcnInfoInptReqIntro" },
      component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReq"),
      children: [
        {
          path: "intro",
          name: "ovsesRmtancAplcnInfoInptReqIntro",
          description: "해외송금신청-Intro",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqIntro"),
          meta: {
            roles: ["login"],
            step: 1,
            transparent: true,
          },
        },
        {
          path: "step1",
          name: "ovsesRmtancAplcnInfoInptReqStep1",
          description: "해외송금신청-step1",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqStep1"),
          meta: {
            roles: ["login"],
            step: 2,
            transparent: true,
          },
        },
        {
          path: "step2",
          name: "ovsesRmtancAplcnInfoInptReqStep2",
          description: "해외송금신청-step2",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqStep2"),
          meta: {
            roles: ["login"],
            step: 3,
            transparent: true,
          },
        },
        {
          path: "step3",
          name: "ovsesRmtancAplcnInfoInptReqStep3",
          description: "해외송금신청-step3",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqStep3"),
          meta: {
            roles: ["login"],
            step: 4,
            transparent: true,
          },
        },
        {
          path: "step4",
          name: "ovsesRmtancAplcnInfoInptReqStep4",
          description: "해외송금신청-step4",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqStep4"),
          meta: {
            roles: ["login"],
            step: 5,
            transparent: true,
          },
        },
        {
          path: "step5",
          name: "ovsesRmtancAplcnInfoInptReqStep5",
          description: "해외송금신청-step5",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqStep5"),
          meta: {
            roles: ["login"],
            step: 6,
            transparent: true,
          },
        },
        {
          path: "step6",
          name: "ovsesRmtancAplcnInfoInptReqStep6",
          description: "해외송금신청-step6",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqStep6"),
          meta: {
            roles: ["login"],
            step: 7,
            transparent: true,
            firstPage: "ovsesRmtancAplcnInfoInptReqIntro",
          },
        },
        // {
        //   path: "step7",
        //   name: "ovsesRmtancAplcnInfoInptReqStep7",
        //   description: "해외송금신청-step8",
        //   component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoInptReqStep7"),
        //   meta: {
        //     roles: ["login"],
        //     firstPage: "ovsesRmtancAplcnInfoInptReqIntro",
        //   },
        // },
        {
          path: "complete",
          name: "ovsesRmtancAplcnInfoComplete",
          description: "해외송금신청-완료",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInfoComplete"),
          meta: {
            roles: ["login"],
            isLast: true,
            transparent: true,
          },
        },
        {
          path: "approvalComplete",
          name: "ovsesRmtancAplcnInfoApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    /*
    {
      path: "ovsesRmtancAplcnInq",
      name: "ovsesRmtancAplcnInq",
      description: "해외송금신청내역조회",
      component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInq"),
      meta: {
        roles: ["login"],
      },
    },
    */
    {
      path: "ovsesRmtancAplcnCnclReq",
      name: "ovsesRmtancAplcnCnclReq",
      redirect: { name: "ovsesRmtancAplcnInq" },
      component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnCnclReq"),
      children: [
        {
          path: "ovsesRmtancAplcnInq",
          name: "ovsesRmtancAplcnInq",
          description: "해외송금신청내역조회",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnInq"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "ovsesRmtancAplcnCnclReqStep1",
          name: "ovsesRmtancAplcnCnclReqStep1",
          description: "해외송금신청취소-Step1",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnCnclReqStep1"),
          meta: {
            roles: ["login"],
            firstPage: "ovsesRmtancAplcnInq",
            step: 2,
          },
        },
        {
          path: "ovsesRmtancAplcnCnclReqStep2",
          name: "ovsesRmtancAplcnCnclReqStep2",
          description: "해외송금신청취소-Step2",
          component: () => import("@/views/templates/foreignExchange/ovsesRmtancAplcnCnclReqStep2"),
          meta: {
            roles: ["login"],
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "ovsesRmtancAplcnCnclApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "ovsesRmtancRcevns",
      name: "ovsesRmtancRcevns",
      description: "해외송금 수취조회",
      component: () => import("@/views/templates/foreignExchange/ovsesRmtancRcevns"),
      meta: {
        roles: ["login"],
      },
    },
    {
      path: "ovsesRmtancDocsList",
      name: "ovsesRmtancDocsList",
      description: "송금에 필요한 서류",
      component: () => import("@/views/templates/foreignExchange/ovsesRmtancDocsList"),
    },
    {
      path: "foreignExchange",
      redirect: rootPath + "/foreignExchange/inqury",
      component: () => import("@/views/templates/foreignExchange/foreignExchangeParent"),
      description: "환율",
      children: [
        {
          path: "inqury",
          name: "foreignExchange",
          description: "환율조회",
          component: () => import("@/views/templates/foreignExchange/foreignExchange"),
          meta: {
            step: 1,
          },
        },
        {
          path: "inquryDtl",
          name: "foreignExchangeDtl",
          description: "환율조회상세",
          component: () => import("@/views/templates/foreignExchange/foreignExchangeDtl"),
          meta: {
            isLast: true,
          },
        },
        {
          path: "exrtFlxblPrgrs",
          name: "exrtFlxblPrgrs",
          description: "환율변동추이",
          component: () => import("@/views/templates/foreignExchange/exrtFlxblPrgrs"),
        },
        // {
        //   path: "fndsMaktIrtInq",
        //   name: "fndsMaktIrtInq",
        //   description: "자금시장금리조회",
        //   component: () => import("@/views/Templates/foreignExchange/fndsMaktIrtInq"),
        // },
        // {
        //   path: "exrtFlxblPrgrs",
        //   name: "exrtFlxblPrgrs",
        //   description: "환율변동추이",
        //   component: () => import("@/views/Templates/foreignExchange/exrtFlxblPrgrs"),
        // },
        // {
        //   path: "exrtCalc",
        //   name: "exrtCalc",
        //   description: "환율계산기",
        //   component: () => import("@/views/Templates/foreignExchange/exrtCalc"),
        // },
        {
          path: "exrtCalc",
          name: "exrtCalc",
          description: "환율계산기",
          component: () => import("@/views/templates/foreignExchange/exrtCalc"),
        },
      ],
    },
  ],
};

export default foreignExchange;
